export class ShowMenu {
  public static readonly type = '[MenuDisplay] ShowMenu';
}
